import { useFormik } from 'formik';
import { useEffect } from 'react';
import { LegalProceeding } from '../../../../../../shared/types/legalProceedings/legalProceedings';

export const useLegalProceedingsRegisterHistory = (
    legalProceeding?: LegalProceeding
) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = legalProceeding || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [legalProceeding]);

    return {
        formik,
    };
};
